import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { MembershipSubscriptionDto } from '../../../models/user-membership/dto/user-membership.dto';
import { GET_USER_BY_ID_QUERY_KEY } from './useGetUser';

export const GET_USER_SUBSCRIPTIONS_QUERY_KEY = (userId: string) => [
    ...GET_USER_BY_ID_QUERY_KEY(userId),
    'subscriptions',
];

/**
 * ONE member's subscriptions — the per-user read that Sentry DASHBOARD-17 was
 * missing.
 *
 * Before this hook the only way to get a member's subscriptions was the
 * org-wide `users/with-memberships` roster, so `DuoAttachmentCard` downloaded
 * every subscribed user in the organization (full user DTOs incl. email, plus
 * their memberships and subscriptions) on every member page load, purely to
 * `.find()` one entry — and then usually rendered nothing. Sentry's
 * large-HTTP-payload detector filed the result as DASHBOARD-17.
 *
 * `enabled` mirrors `useGetUserMemberships`: without it a template literal
 * stringifies an unresolved id into `users/undefined/subscriptions` (the
 * MYSPORTSET-API-EC / API-JD defect class, which has produced two separate
 * Sentry issues in this codebase already).
 */
export const useGetUserSubscriptions = (userId: string) => {
    const apiClient = useApiClient();

    return useQuery({
        enabled: Boolean(userId),
        queryKey: GET_USER_SUBSCRIPTIONS_QUERY_KEY(userId),
        queryFn: () =>
            apiClient.fetchApi<MembershipSubscriptionDto[], {}>({
                method: 'GET',
                endpoint: `users/${userId}/subscriptions`,
            }),
    });
};
